/* eslint-disable camelcase */
import React from 'react';
import {
  DateTime,
} from 'luxon';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';
import {
  useNavigate,
} from 'react-router';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Avatar,
  Select,
  ClientSearchOption,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

const mapState = state => ({
  conversations: coreSelectors.getConversations(state),
  conversationOptions: coreSelectors.getConversationOptions(state),
});

type Props = {
  id: number,
};

const Conversations = ({ id }: Props) => {
  const navigate = useNavigate();
  const {
    conversations,
    conversationOptions,
  } = useSelector(mapState, shallowEqual);

  return (
    <S.Items>
      <S.Search>
        <Select
          value=""
          isClearable
          options={conversationOptions}
          components={{ Option: ClientSearchOption }}
          placeholder="Search conversations"
          onChange={(item) => {
            if (item?.value) {
              navigate(`/messages/${item.value}/1`);
            }
          }}
        />
      </S.Search>
      <Flex column width="100%" scrollY>
        {conversations.map(conversation => {
          const date = DateTime.fromISO(conversation.updated_at);
          return (
            <S.Item
              key={conversation.id}
              selected={conversation.id === Number(id)}
              hasUnread={conversation.has_unread_messages}
              onClick={() => {
                navigate(`/messages/${conversation.id}/1`);
              }}
            >
              <Avatar
                width="28px"
                height="28px"
                src={conversation.recipient?.avatar}
              />
              <Flex
                justify="space-between"
                width="calc(100% - 38px)"
                className="messageData"
              >
                <Flex
                  column
                  width="calc(100% - 60px)"
                  className="bodyWrap"
                >
                  <S.ItemText>
                    <b>
                      {conversation.recipient?.full_name}
                    </b>
                  </S.ItemText>
                  <S.ItemText>
                    {conversation.last_message?.body}
                  </S.ItemText>
                </Flex>
                <Text align="right">
                  <b>
                    {date.toFormat('hh:mm a')}
                  </b>
                  <br />
                  {date.toFormat('LL/dd/yy')}
                </Text>
              </Flex>
            </S.Item>
          );
        })}
      </Flex>
    </S.Items>
  );
};

export default Conversations;
